module.exports = __webpack_public_path__ + "static/img/user-bg01.8cb4a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/images/bg/user-bg01.png
// module id = Pet3
// module chunks = 1